import {Component} from 'panel';

export default class extends Component {
  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      'disabled': `boolean`,
    };
  }

  get config() {
    return {
      useShadowDom: true,
      helpers: {
        getComponentClasses: prefixFilter => {
          const componentClasses = {};
          for (const className of this.classList) {
            if (className.startsWith(prefixFilter)) {
              componentClasses[className] = true;
            }
          }
          return componentClasses;
        },
        getButtonAttrs: () => {
          const attrs = {};
          if (this.attrs[`disabled`]) {
            attrs.disabled = true;
          }
          return attrs;
        },
      },
    };
  }

  get disabled() {
    return this.attrs[`disabled`];
  }

  set disabled(disabled) {
    this.setAttribute(`disabled`, disabled);
  }

  connectedCallback() {
    super.connectedCallback(...arguments);

    // don't dispatch click event if disabled
    this._clickHandler = e => {
      if (this.attrs[`disabled`]) {
        e.stopImmediatePropagation();
      }
    };
    this.el.addEventListener(`click`, this._clickHandler);
  }

  disconnectedCallback() {
    super.disconnectedCallback(...arguments);
    this.el.removeEventListener(`click`, this._clickHandler);
    this._clickHandler = null;
  }
}



// WEBPACK FOOTER //
// ../iron/common/components/base/button.js